<template>
  <div class="body-container">
    <h2><span class="mdi mdi-account mdi-36px"></span>アクションの設定</h2>
    <!-- ローディング画面 -->
    <div style="position: fixed; z-index: 100; width: 100vw; height: 100vh; background: white; top: 0;" v-if="isCalendarActionLoading">
      <Loading/>
    </div>
    <!-- 正常に読み込んだ場合 -->
    <template v-if="!isCalendarActionLoading">
      <!-- 応募者日程選択（仮） -->
      <div style="padding: 16px; border: solid thin #ccc; border-radius: 8px; text-align: left;">
        <p>
          下記日付の内、ご都合のよろしい日程を一つお選びください。<br>
          ※「閉じる」を選択するとページを一度閉じます。<br>
        </p>
        <div style="padding: 8px;">
          日程の選択：
          <select class="select" v-model="temp">
            <option v-for="(t, idx) in temporaryEvents" :key="idx" :value="t">
              {{t.date_str}}
            </option>
          </select>
        </div>
        <div style="display: flex; justify-content: center;">
          <button @click="createEvent()" class="button is-primary" style="margin-right: 8px;">選　択</button>
          <button @click="closePage()" class="button is-danger">閉じる</button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex"
import Loading from '@/components/animations/Loading'
export default {
  name: "CalendarAction",
  componentName: "CalendarAction",
  components: {
    Loading
  },
  computed: {
    ...mapState('calendar', ['temporaryEvents', 'isCalendarActionLoading'])
  },
  data () {
    return {
      temp: null
    }
  },
  mounted () {
    this.$store.dispatch('calendar/getTemporaryEvent', this.$route.query.id)
  },
  methods: {
    createEvent () {
      for (const t of this.temporaryEvents) {
        if (t.answer_list.indexOf(this.$route.query.uid) >= 0) {
          alert('既に本日程の回答は行っておりますため、ウィンドウを閉じます。')
          this.closePage()
          return
        }
      }
      let tempEvent = this.temp
      tempEvent.uuid = this.$route.query.uid
      tempEvent.calendarType = this.$route.query.type
      this.$store.dispatch('calendar/createAndDeleteEvent', tempEvent)
    },
    closePage () {
      window.close()
    }
  }
};
</script>

<style scoped>
.body-container {
  background: #fbfbfb;
  width: 100vw;
  height: 100vh;
  text-align: center;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
h2 {
  font-size: 24px;
  font-weight: 600;
  padding: 40px 20px;
}
h2 > span {
  margin-right: 10px;
}
.edit-box {
  width: 90%;
  max-width: 700px;
  height: 500px;
  border: solid thin #ccc;
}
.edit-column {
  width: 70%;
  max-width: 400px;
  min-width: 250px;
  margin: 15px auto;
}
.img-icon {
  width: 120px;
  height: 120px;
  object-fit: cover;
  background: #FEFEFE;
}
.left-in {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.right-bt {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Calendar/CalendarAction.vue